(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["redirect-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'rs_sewershop_popup_dismissed';

    const dialogComponent = document.getElementById('redirect-modal');
    const dataset = dialogComponent ? dialogComponent.dataset : {};

    const LAUNCH_TS = new Date((dataset.launchDate || '2026-05-14') + 'T00:00:00').getTime();
    const SUNSET_MS = parseInt(dataset.sunsetDays || 30, 10) * 24 * 60 * 60 * 1000;

    function isSunset() {
      return Date.now() > LAUNCH_TS + SUNSET_MS;
    }

    function hasBeenDismissed() {
      return localStorage.getItem(STORAGE_KEY) === '1';
    }

    function markDismissed() {
      localStorage.setItem(STORAGE_KEY, '1');
      sessionStorage.removeItem('from_sewershop');
    }

    function shouldShow() {
      return !isSunset() && !hasBeenDismissed();
    }

    function init() {
      if (!shouldShow()) return;

      customElements.whenDefined('dialog-component').then(function () {
        if (typeof dialogComponent.showDialog === 'function') {
          dialogComponent.showDialog();
        }
      });

      // The native <dialog> 'close' event fires for ALL close paths:
      // close button, click-outside, and Escape — anything dialog.js handles.
      const nativeDialog = dialogComponent.querySelector('dialog');
      if (nativeDialog) {
        nativeDialog.addEventListener('close', function () {
          markDismissed();
        }, { once: true });
      }

      // CTA click — user has clearly seen it, mark dismissed before navigating
      const cta = dialogComponent.querySelector('.redirect-modal-cta');
      if (cta) {
        cta.addEventListener('click', function () {
          markDismissed();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-read-more], [data-read-less]').forEach((button) => {
      button.addEventListener('click', function () {
        const wrapper = button.closest('.text-block__read-more-wrapper');

        if (!wrapper) return;

        if (button.matches('[data-read-more]')) {
          wrapper.setAttribute('data-expanded', '');
        } else {
          wrapper.removeAttribute('data-expanded');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
